import { Path, Svg } from 'react-native-svg';

import { IconProps } from '../types';

export const IconRewards3D = (props: IconProps) => {
  const { size = 208, ...otherProps } = props;

  return (
    <Svg width={size} height={(size * 31) / 208} fill="none" viewBox="0 0 208 31" {...otherProps}>
      <Path
        d="M0.5992 1.66448L3.04038 4.11676C2.85175 3.92812 2.65201 3.79497 2.44118 3.71729L0 1.26501C0.21083 1.34269 0.421659 1.47584 0.5992 1.66448Z"
        fill="#E1A61B"
      />
      <Path d="M12.5721 5.44824L15.0133 7.90052H11.8397L9.38745 5.44824H12.5721Z" fill="#E1A61B" />
      <Path
        d="M16.6 6.59116L19.0412 9.04344C18.1424 8.13355 16.7109 7.90052 15.0132 7.90052L12.572 5.44824C14.2698 5.44824 15.7012 5.69236 16.6 6.59116Z"
        fill="#E1A61B"
      />
      <Path
        d="M9.38745 5.44824L11.8397 7.90052L11.873 16.4336L9.42074 13.9813L9.38745 5.44824Z"
        fill="#E1A61B"
      />
      <Path
        d="M11.8064 18.6085L14.2476 21.0719L11.8841 21.0608L9.44287 18.6085H11.8064Z"
        fill="#E1A61B"
      />
      <Path
        d="M9.44287 18.6085L11.8841 21.0608L11.9062 26.3537L9.46506 23.9015L9.44287 18.6085Z"
        fill="#E1A61B"
      />
      <Path
        d="M12.6941 29.3276L10.2529 26.8753C9.67592 26.2872 9.47618 25.3995 9.46509 23.9015L11.9063 26.3538C11.9063 27.8518 12.106 28.7506 12.6941 29.3276Z"
        fill="#E1A61B"
      />
      <Path d="M10.9854 27.3745L13.4376 29.8268V30.2928L10.9854 27.8406V27.3745Z" fill="#E1A61B" />
      <Path
        d="M10.9853 27.8406L13.4376 30.2929H2.55213L0.0998535 27.8406H10.9853Z"
        fill="#E1A61B"
      />
      <Path
        d="M23.0359 3.8504L25.4771 6.30269C26.7975 7.63424 27.6076 9.50951 27.6187 12.1504C27.6409 16.822 25.122 19.1411 21.6821 20.2174L19.241 17.7652C22.6808 16.6888 25.1997 14.3697 25.1775 9.69815C25.1775 7.05723 24.3564 5.17086 23.0359 3.8504Z"
        fill="#E1A61B"
      />
      <Path
        d="M19.241 17.7652L21.6821 20.2175L24.9556 25.0887L22.5144 22.6365L19.241 17.7652Z"
        fill="#E1A61B"
      />
      <Path
        d="M28.1734 29.1389L25.7322 26.6866C24.9222 25.8655 23.8458 24.6116 22.5254 22.6365L24.9666 25.0888C26.2981 27.0639 27.3634 28.3178 28.1734 29.1389Z"
        fill="#E1A61B"
      />
      <Path
        d="M22.5147 22.6365C24.3123 25.2996 25.6328 26.6533 26.4872 27.3857V27.8517H15.0248V27.3857C16.1788 26.5313 15.8681 24.6005 13.7265 21.4381L11.8179 18.6196H9.45442L9.47661 23.9125C9.47661 25.921 9.83169 26.8531 10.9968 27.3857V27.8517H0.111341V27.3857C1.54276 26.842 2.30841 23.9902 2.28621 18.6196L2.25293 10.0422C2.23073 4.67156 1.4429 1.81982 0.0114746 1.2761V0.810059H12.1397C18.6532 0.810059 25.1668 2.1638 25.189 9.69818C25.2111 14.3697 22.6923 16.6889 19.2524 17.7652L22.5258 22.6365H22.5147ZM12.6058 13.9814C15.513 13.9814 17.6435 13.2934 17.6213 9.69818C17.6102 6.14737 15.4686 5.44831 12.5725 5.44831H9.39894L9.43223 13.9814H12.6058Z"
        fill="#C40000"
      />
      <Path
        d="M26.4867 27.8517L28.9279 30.304L17.4655 30.2929L15.0132 27.8406L26.4867 27.8517Z"
        fill="#E1A61B"
      />
      <Path d="M26.4868 27.3857L28.928 29.838V30.304L26.4868 27.8517V27.3857Z" fill="#E1A61B" />
      <Path
        d="M28.5396 1.68676L30.9808 4.13904C30.7922 3.9504 30.5924 3.81725 30.3816 3.73957L27.9404 1.28729C28.1513 1.36497 28.3621 1.49812 28.5396 1.68676Z"
        fill="#E1A61B"
      />
      <Path
        d="M37.3276 5.45941L39.7688 7.91169L39.791 14.281L37.3498 11.8287L37.3276 5.45941Z"
        fill="#E1A61B"
      />
      <Path
        d="M47.2588 8.74391L49.7 11.1962C47.6583 9.14338 44.8731 7.91169 39.7688 7.91169L37.3276 5.45941C42.4319 5.45941 45.2171 6.70219 47.2588 8.74391Z"
        fill="#E1A61B"
      />
      <Path d="M49.4006 10.7967L51.8418 13.249H51.3758L48.9346 10.7967H49.4006Z" fill="#E1A61B" />
      <Path
        d="M49.356 0.0222778L51.7971 2.47456L51.8415 13.2491L49.4003 10.7968L49.356 0.0222778Z"
        fill="#E1A61B"
      />
      <Path
        d="M37.3721 16.467L39.8133 18.9193L39.8354 25.7546L37.3943 23.3023L37.3721 16.467Z"
        fill="#E1A61B"
      />
      <Path
        d="M44.1852 17.6653L46.6264 20.1176C45.7942 19.2854 44.396 18.9858 39.8133 18.9081L37.3721 16.4558C41.9548 16.5224 43.353 16.8331 44.1852 17.6653Z"
        fill="#E1A61B"
      />
      <Path d="M44.9731 18.0536L47.4143 20.5059H46.9483L44.5071 18.0536H44.9731Z" fill="#E1A61B" />
      <Path
        d="M44.9399 10.253L47.3811 12.7053L47.4144 20.506L44.9732 18.0537L44.9399 10.253Z"
        fill="#E1A61B"
      />
      <Path
        d="M50.5879 17.976L53.0291 20.4282L53.0735 30.315L50.6212 27.8628L50.5879 17.976Z"
        fill="#E1A61B"
      />
      <Path
        d="M50.621 27.8628L53.0733 30.3151L30.4812 30.304L28.04 27.8517L50.621 27.8628Z"
        fill="#E1A61B"
      />
      <Path
        d="M49.3561 0.0221931L49.4005 10.7967H48.9345C46.6708 7.55657 43.9522 5.45937 37.3278 5.45937L37.3499 11.8286C42.5763 11.751 43.6637 11.3737 44.4738 10.253H44.9398L44.9731 18.0537H44.5071C43.6859 16.9329 42.5985 16.5446 37.3721 16.4669L37.3943 23.3022H39.6469C45.1839 23.3022 47.8914 21.2272 50.1218 17.976H50.5878L50.6211 27.8628H28.0291V27.3856C29.4605 26.8419 30.2261 23.9902 30.2039 18.6196L30.1706 10.0421C30.1485 4.67153 29.3606 1.81979 27.9292 1.27607V0.810029H41.2891C45.1617 0.810029 47.6029 0.499333 48.879 0H49.345L49.3561 0.0221931Z"
        fill="#C40000"
      />
      <Path
        d="M53.4175 2.14166L55.8587 4.59394C55.4814 4.21667 55.0264 3.96145 54.5049 3.75062L52.0637 1.29834C52.5852 1.50917 53.0291 1.76439 53.4175 2.14166Z"
        fill="#E1A61B"
      />
      <Path
        d="M63.4153 0.843384L65.8676 3.29566V3.76171L63.4264 1.29833L63.4153 0.843384Z"
        fill="#E1A61B"
      />
      <Path
        d="M63.4264 1.29834L65.8675 3.75062C63.7814 4.4053 63.7371 4.98231 64.1698 6.99074L61.7286 4.53846C61.2959 2.53003 61.3292 1.95302 63.4264 1.29834Z"
        fill="#E1A61B"
      />
      <Path
        d="M69.3961 1.79762L71.8373 4.2499C71.6597 4.07236 71.4267 3.91701 71.1382 3.76167L68.697 1.30939C68.9966 1.47583 69.2296 1.63118 69.3961 1.79762Z"
        fill="#E1A61B"
      />
      <Path
        d="M78.5728 0.843384L81.0139 3.30676V3.76171L78.5728 1.30943V0.843384Z"
        fill="#E1A61B"
      />
      <Path
        d="M78.5728 1.30939L81.014 3.76167C79.8156 4.41635 79.6602 4.99335 80.2483 7.00178L77.8071 4.5495C77.219 2.54107 77.3744 1.96407 78.5728 1.30939Z"
        fill="#E1A61B"
      />
      <Path
        d="M61.7288 4.5495L64.1699 7.00178L67.4877 22.4922L65.0465 20.0288L61.7288 4.5495Z"
        fill="#E1A61B"
      />
      <Path
        d="M85.397 2.08608L87.8382 4.53836C87.5386 4.23876 87.0503 4.01683 86.2847 3.77271L83.8435 1.32043C84.6091 1.56455 85.1085 1.79757 85.397 2.08608Z"
        fill="#E1A61B"
      />
      <Path
        d="M73.5685 11.0408L76.0208 13.4931L71.4602 27.7074L69.019 25.244L73.5685 11.0408Z"
        fill="#E1A61B"
      />
      <Path
        d="M71.4933 29.5605L69.0521 27.1082C68.6083 26.6644 68.7747 26.0208 69.0189 25.2551L71.46 27.7074C71.2159 28.4731 71.0495 29.1166 71.4933 29.5605Z"
        fill="#E1A61B"
      />
      <Path
        d="M95.1951 0.854431L97.6362 3.30671V3.77275L95.1951 1.32047V0.854431Z"
        fill="#E1A61B"
      />
      <Path
        d="M95.195 1.32043L97.6362 3.77271C96.5155 4.23876 95.7387 4.84905 95.2505 6.62446L92.8093 4.17218C93.3087 2.39677 94.0743 1.77538 95.195 1.32043Z"
        fill="#E1A61B"
      />
      <Path d="M69.5294 27.8738L71.9705 30.3261H62.4055L59.9644 27.8738H69.5294Z" fill="#E1A61B" />
      <Path d="M69.5293 27.4077L71.9705 29.86V30.326L69.5293 27.8738V27.4077Z" fill="#E1A61B" />
      <Path
        d="M77.8071 4.5495L80.2483 7.01288L84.8089 22.4922L82.3566 20.0399L77.8071 4.5495Z"
        fill="#E1A61B"
      />
      <Path
        d="M92.7982 4.17224L95.2505 6.63562L89.4361 27.7075L86.9949 25.2552L92.7982 4.17224Z"
        fill="#E1A61B"
      />
      <Path
        d="M89.5026 29.5827L87.0614 27.1304C86.6176 26.6865 86.784 26.0319 86.9949 25.2551L89.436 27.7074C89.2252 28.4841 89.0588 29.1277 89.5026 29.5827Z"
        fill="#E1A61B"
      />
      <Path
        d="M95.195 0.854459V1.3205C94.0743 1.78655 93.2975 2.39684 92.8093 4.17225L86.9948 25.2552C86.7285 26.2206 86.5399 26.9973 87.5053 27.419V27.885H77.7405V27.419C78.7503 26.9973 78.5506 26.2206 78.2288 25.2552L73.5683 11.0408L69.0078 25.2441C68.6971 26.2095 68.5084 26.9862 69.5182 27.4079V27.8739H59.9532V27.4079C60.9186 26.9862 60.7188 26.2095 60.4414 25.2441L54.4716 4.15005C53.9612 2.37465 53.1844 1.75326 52.0637 1.28721V0.821167H63.4152V1.28721C61.3291 1.94189 61.2958 2.5189 61.7286 4.52733L65.0464 20.0178L69.4849 4.53843C70.0619 2.53 69.9066 1.95299 68.6971 1.29831V0.832266H78.5728V1.29831C77.3744 1.95299 77.219 2.53 77.8071 4.53843L82.3566 20.0288L85.5523 4.54952C85.974 2.54109 85.9296 1.96409 83.8324 1.30941V0.84336H95.1839L95.195 0.854459Z"
        fill="#C40000"
      />
      <Path d="M87.5052 27.885L89.9575 30.3373H80.1928L77.7405 27.885H87.5052Z" fill="#E1A61B" />
      <Path
        d="M87.5054 27.4189L89.9466 29.8712L89.9577 30.3372L87.5054 27.8849V27.4189Z"
        fill="#E1A61B"
      />
      <Path
        d="M105.603 1.65338L108.045 4.10566C107.923 3.9836 107.745 3.87264 107.512 3.77277L105.071 1.3205C105.304 1.40927 105.481 1.52023 105.603 1.65338Z"
        fill="#E1A61B"
      />
      <Path d="M115.845 0.865479L118.286 3.31776V3.7838L115.845 1.33152V0.865479Z" fill="#E1A61B" />
      <Path
        d="M115.845 1.3316L118.286 3.78389C117.199 4.20555 117.443 4.98229 117.787 5.94766L115.346 3.49538C114.991 2.53 114.758 1.75326 115.845 1.3316Z"
        fill="#E1A61B"
      />
      <Path
        d="M110.286 8.12256L112.738 10.5748L109.864 20.1176L107.423 17.6654L110.286 8.12256Z"
        fill="#E1A61B"
      />
      <Path
        d="M106.003 22.2925L108.444 24.7448L107.878 26.6422L105.426 24.1899L106.003 22.2925Z"
        fill="#E1A61B"
      />
      <Path
        d="M107.922 29.0722L105.481 26.62C104.982 26.1206 105.026 25.4216 105.426 24.1899L107.867 26.6422C107.467 27.8739 107.412 28.5618 107.922 29.0722Z"
        fill="#E1A61B"
      />
      <Path
        d="M107.146 27.43L109.587 29.8823L109.598 30.3483L107.146 27.896V27.43Z"
        fill="#E1A61B"
      />
      <Path
        d="M107.146 27.896L109.598 30.3483H98.513L96.0718 27.8849L107.146 27.896Z"
        fill="#E1A61B"
      />
      <Path
        d="M114.569 22.3036L117.01 24.7559L108.444 24.7448L106.003 22.2925L114.569 22.3036Z"
        fill="#E1A61B"
      />
      <Path
        d="M115.346 3.49536L117.787 5.94764L125.077 27.0417L122.636 24.5894L115.346 3.49536Z"
        fill="#E1A61B"
      />
      <Path
        d="M126.232 29.0944L123.79 26.6422C123.347 26.1983 122.991 25.5658 122.636 24.5782L125.078 27.0305C125.422 28.0181 125.788 28.6506 126.232 29.0944Z"
        fill="#E1A61B"
      />
      <Path
        d="M125.044 27.9072L127.496 30.3595L115.867 30.3484L113.426 27.8961L125.044 27.9072Z"
        fill="#E1A61B"
      />
      <Path d="M125.044 27.4411L127.496 29.8934V30.3594L125.044 27.9072V27.4411Z" fill="#E1A61B" />
      <Path
        d="M122.636 24.5896C123.258 26.365 123.923 26.9864 125.044 27.4524V27.9185H113.426V27.4524C115.512 26.7978 115.745 26.2208 115.113 24.2123L114.558 22.3149H105.992L105.415 24.2012C104.76 26.2097 105.037 26.7867 107.135 27.4413V27.9074H96.0605V27.4413C97.1813 26.9753 97.836 26.365 98.4463 24.5896L105.57 3.50665C105.914 2.54128 106.147 1.76454 105.06 1.34288V0.876831H115.823V1.34288C114.747 1.76454 114.98 2.54128 115.335 3.50665L122.625 24.6007L122.636 24.5896ZM107.423 17.6655H113.16L110.297 8.13381L107.423 17.6655Z"
        fill="#C40000"
      />
      <Path
        d="M127.097 1.7423L129.538 4.19458C129.35 4.00594 129.15 3.87279 128.939 3.79511L126.498 1.34283C126.709 1.42051 126.919 1.55366 127.097 1.7423Z"
        fill="#E1A61B"
      />
      <Path d="M139.07 5.51501L141.511 7.9673H138.338L135.885 5.51501H139.07Z" fill="#E1A61B" />
      <Path
        d="M143.098 6.65794L145.539 9.11021C144.64 8.20032 143.209 7.9673 141.511 7.9673L139.07 5.51501C140.768 5.51501 142.199 5.75914 143.098 6.65794Z"
        fill="#E1A61B"
      />
      <Path
        d="M135.885 5.51501L138.338 7.9673L138.371 16.5003L135.919 14.0481L135.885 5.51501Z"
        fill="#E1A61B"
      />
      <Path d="M138.304 18.6863L140.745 21.1386H138.382L135.941 18.6863H138.304Z" fill="#E1A61B" />
      <Path
        d="M135.941 18.6863L138.382 21.1386L138.404 26.4315L135.963 23.9792L135.941 18.6863Z"
        fill="#E1A61B"
      />
      <Path
        d="M139.192 29.4051L136.751 26.9529C136.174 26.3648 135.974 25.4771 135.963 23.9791L138.404 26.4313C138.404 27.9293 138.604 28.8281 139.192 29.4051Z"
        fill="#E1A61B"
      />
      <Path
        d="M137.483 27.4522L139.924 29.9045L139.935 30.3705L137.483 27.9183V27.4522Z"
        fill="#E1A61B"
      />
      <Path
        d="M137.483 27.9183L139.935 30.3705L129.039 30.3594L126.598 27.9072L137.483 27.9183Z"
        fill="#E1A61B"
      />
      <Path
        d="M149.534 3.91699L151.975 6.36927C153.295 7.70083 154.105 9.5761 154.116 12.217C154.139 16.8886 151.62 19.2077 148.18 20.284L145.739 17.8317C149.178 16.7554 151.697 14.4363 151.675 9.76473C151.675 7.12382 150.854 5.23745 149.534 3.91699Z"
        fill="#E1A61B"
      />
      <Path
        d="M145.739 17.8429L148.18 20.2952L151.453 25.1553L149.012 22.7031L145.739 17.8429Z"
        fill="#E1A61B"
      />
      <Path
        d="M154.671 29.2055L152.23 26.7532C151.42 25.9321 150.344 24.6782 149.023 22.7031L151.464 25.1553C152.796 27.1305 153.861 28.3844 154.671 29.2055Z"
        fill="#E1A61B"
      />
      <Path
        d="M149.012 22.7031C150.81 25.3662 152.13 26.72 152.985 27.4523V27.9184H141.522V27.4523C142.676 26.5979 142.366 24.6672 140.224 21.5047L138.315 18.6863H135.952L135.974 23.9792C135.974 25.9876 136.329 26.9197 137.494 27.4523V27.9184H126.609V27.4523C128.04 26.9086 128.806 24.0569 128.784 18.6863L128.75 10.1088C128.728 4.73822 127.94 1.88647 126.509 1.34276V0.876709H138.637C145.151 0.876709 151.664 2.23045 151.686 9.76483C151.709 14.4364 149.19 16.7555 145.75 17.8318L149.023 22.7031H149.012ZM139.103 14.048C142.01 14.048 144.141 13.36 144.119 9.76483C144.097 6.16964 141.966 5.51496 139.07 5.51496H135.896L135.93 14.048H139.103Z"
        fill="#C40000"
      />
      <Path d="M152.985 27.9183L155.426 30.3706H143.963L141.511 27.9183H152.985Z" fill="#E1A61B" />
      <Path d="M152.984 27.4633L155.426 29.9155V30.3705L152.984 27.9182V27.4633Z" fill="#E1A61B" />
      <Path
        d="M155.037 1.75341L157.478 4.20569C157.29 4.01705 157.09 3.8839 156.879 3.80623L154.438 1.35394C154.649 1.43162 154.86 1.56477 155.037 1.75341Z"
        fill="#E1A61B"
      />
      <Path
        d="M165.412 5.52612L167.853 7.9895L166.267 7.97841L163.825 5.52612H165.412Z"
        fill="#E1A61B"
      />
      <Path
        d="M171.737 7.53451L174.178 9.98678C172.825 8.62194 170.75 7.98945 167.842 7.98945L165.401 5.53717C168.297 5.53717 170.372 6.18076 171.737 7.53451Z"
        fill="#E1A61B"
      />
      <Path
        d="M163.825 5.52612L166.267 7.97841L166.333 25.7436L163.892 23.2913L163.825 5.52612Z"
        fill="#E1A61B"
      />
      <Path
        d="M165.956 27.9295L168.408 30.3818H156.979L154.527 27.9184L165.956 27.9295Z"
        fill="#E1A61B"
      />
      <Path
        d="M177.984 4.86029L180.426 7.31257C182.656 9.55402 183.755 12.6721 183.766 16.4892C183.799 25.0999 178.861 30.3929 168.397 30.3818L165.956 27.9295C176.42 27.9295 181.358 22.6476 181.324 14.0369C181.313 10.2309 180.215 7.10174 177.984 4.86029Z"
        fill="#E1A61B"
      />
      <Path
        d="M165.856 0.898973C176.32 0.898973 181.291 5.89231 181.324 14.037C181.358 22.6477 176.42 27.9406 165.956 27.9295H154.527V27.4635C155.958 26.9198 156.724 24.068 156.702 18.6974L156.668 10.12C156.646 4.74938 155.858 1.89764 154.427 1.35392V0.887878H165.856V0.898973ZM165.479 23.2913C171.327 23.2913 173.801 19.9402 173.768 14.0259C173.746 8.12266 171.26 5.52613 165.401 5.52613H163.814L163.881 23.2913H165.468"
        fill="#C40000"
      />
      <Path
        d="M188.304 16.3449L185.863 13.8926C186.817 14.858 188.138 15.5126 189.78 15.9787L192.221 18.431C190.579 17.9649 189.258 17.3102 188.304 16.3449Z"
        fill="#E1A61B"
      />
      <Path
        d="M188.837 22.3702L186.395 19.9179C185.818 19.3409 185.319 18.6862 184.908 17.9317L187.35 20.384C187.76 21.1385 188.271 21.7932 188.837 22.3702Z"
        fill="#E1A61B"
      />
      <Path
        d="M194.207 17.2104L196.648 19.6627L192.221 18.4199L189.78 15.9676L194.207 17.2104Z"
        fill="#E1A61B"
      />
      <Path
        d="M203.04 8.68844L205.481 11.1407C202.696 8.34445 199.234 7.92279 196.837 7.91169C194.318 7.91169 193.275 8.91036 193.286 10.0755C193.286 10.5859 193.419 10.9965 193.785 11.3737L191.344 8.92146C190.978 8.55528 190.845 8.14471 190.845 7.62318C190.845 6.46917 191.888 5.45941 194.396 5.45941C196.903 5.45941 200.254 5.88107 203.04 8.68844Z"
        fill="#E1A61B"
      />
      <Path d="M184.942 28.3288L187.394 30.7811H186.928L184.476 28.3288H184.942Z" fill="#E1A61B" />
      <Path d="M204.56 9.92023L207.001 12.3725H206.535L204.094 9.92023H204.56Z" fill="#E1A61B" />
      <Path
        d="M204.516 0.343994L206.968 2.79628L207.001 12.3724L204.56 9.9201L204.516 0.343994Z"
        fill="#E1A61B"
      />
      <Path
        d="M197.68 18.8304L200.121 21.2827C199.489 20.6502 198.402 20.1509 196.637 19.6516L194.196 17.1993C195.949 17.6875 197.048 18.1979 197.68 18.8304Z"
        fill="#E1A61B"
      />
      <Path
        d="M204.516 0.343994L204.549 9.9201H204.083C201.165 6.0142 197.092 5.47048 194.385 5.47048C191.866 5.47048 190.823 6.46915 190.834 7.63426C190.834 8.91033 191.655 9.56501 194.917 10.4971L198.368 11.4625C204.105 13.0825 205.548 15.7124 205.57 19.4629C205.592 26.2982 200.144 28.3399 195.45 28.3399C191.966 28.3399 189.17 27.4078 187.194 27.4078C186.185 27.4078 185.486 27.6742 184.953 28.3288H184.487L184.442 17.9427H184.909C186.939 21.6489 191.278 23.1247 194.462 23.1247C197.015 23.1247 198.413 22.4367 198.402 20.6946C198.402 19.0302 197.381 18.1092 194.207 17.2215L189.791 15.9787C186.107 14.9356 184.043 12.9272 184.032 8.63292C184.01 2.45229 188.726 0.521537 193.73 0.532633C197.37 0.532633 200.166 1.38705 202.019 1.38705C203.184 1.38705 203.839 0.965386 204.072 0.343994H204.538H204.516Z"
        fill="#C40000"
      />
      <Path
        d="M203.683 14.1923L206.124 16.6445C207.534 18.0649 208 19.807 208 21.9153C208.022 28.7506 202.574 30.7923 197.88 30.7923C194.396 30.7923 191.599 29.8602 189.624 29.8602C188.615 29.8602 187.915 30.1265 187.383 30.7812L184.942 28.3289C185.485 27.6742 186.173 27.4079 187.183 27.4079C189.158 27.4079 191.955 28.34 195.439 28.34C200.121 28.34 205.581 26.2983 205.559 19.463C205.559 17.3658 205.093 15.6126 203.683 14.1923Z"
        fill="#E1A61B"
      />
    </Svg>
  );
};
